import React from "react";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { BiEdit} from "react-icons/bi";
import { Col, Row, Table } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminData, deleteUser } from "../../services/authServices";
import MainTitle from "../../components/mainTitile/mainTitle";
import TablePagination from "../../components/pagination/tablePagination";
import CustomButton from "../../components/button/button";
import CustomLoader from "../../components/loader/loader";

const UserListComponent = () => {
  const [adminD, setAdminD] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  console.log('page count kya hai',pageCount);
  const [pageData, setPageData] = useState(10);
const [page, setPage] = useState(1);
  let navigate = useNavigate();
  //To take all the data from the backend

  const getuserdata = async () => {
    let params = {
      page,
      limit : pageData,
    };
    setLoading(true);
    try {
      const res = await adminData(params);
      setAdminD(res.data.Data.getAllData);
      setPageCount(res.data.Data.userDocs);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  
  const formpage = () => {
    let path = "/userForm";
    navigate(path);
  };
  
  const handleDelete = (userid, e) => {
    deleteUser(userid);
  };
  
  // pagination ....
  useEffect(() => {
    getuserdata();
  }, [page,pageData]);

  
useEffect(() => {
  const pagedatacount = Math.ceil(pageCount / pageData);
  setPageCount(pagedatacount);
}, [adminD])

  const handleRowSize = (e) =>{
  const { innerHTML } = e.target
  setPageData(innerHTML)
  console.log('row per page size',innerHTML);
}

  return (
    <>
      <CustomLoader isLoading={isLoading} />
      <Row>
        <Col>
          <Row>
            <Col sm={10} className="pt-3">
              <MainTitle heading={"User List"} textAlign={"center"} />
            </Col>

            <Col sm={2}>
              <CustomButton buttonText={"Add"} onClick={formpage} />
            </Col>
          </Row>
          <Table bordered hover responsive>
            <thead className="fs-16 fw-700">
              <tr>
                <th>TMT User ID</th>
                <th>Image</th>
                <th> Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th colSpan={2} className="text-center">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody className="fs-14">
              {adminD
                .filter((a) => a.roleIdf === 2)
                ?.map((aItem) => (
                  <tr>
                    <td>{aItem.tmt_userId}</td>
                    <td>
                      <img src={aItem.image} alt="default" width="20px" />
                    </td>
                    <td>
                      {aItem.title} {aItem.firstname} {aItem.lastname}
                    </td>
                    <td>{aItem.email}</td>
                    <td>{aItem.mobile}</td>
                    <td className="text-center">
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/userForm/${aItem._id}`}
                      >
                        <BiEdit color="green" size={20} />
                      </Link>
                    </td>
                    <td className="text-center">
                      <Link
                        style={{ textDecoration: "none" }}
                        onClick={() => handleDelete(aItem._id)}
                      >
                        <AiFillDelete color="red" size={20}  />
                      </Link>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
{pageCount > 1 &&
<>

          <TablePagination handleRowSize={handleRowSize} setPage={setPage} page={page} pageData={pageData} pageCount={pageCount} />
 </>}
        </Col>
      </Row>
    </>
  );
};

export default UserListComponent;
